import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Component, OnInit, ViewEncapsulation, AfterViewInit, Input } from '@angular/core';

@Component({
  selector: 'offset-swiper',
  templateUrl: './offset-swiper.component.html',
  styleUrls: ['./offset-swiper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OffsetSwiperComponent implements OnInit, AfterViewInit {
  
  //swiper mock images
  // public slides = [
  //   'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype01.jpg',
  //   'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype02.jpg',
  //   'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype03.jpg',
  //   'https://ovsmarketingstorage.blob.core.windows.net/ng-resortui/5763/5763_15_unittype04.jpg',

  // ];

  @Input()
  public slides:Array<string>;
  public offsetSwiperConfig: SwiperConfigInterface = {
    loop: true,
    autoplay: false,
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 4,
    navigation: {
      nextEl: '.offset-swiper__btn--next',
      prevEl: '.offset-swiper__btn--prev',
    },
    // autoHeight: true,
  }

  constructor() { }
  
  ngOnInit() {
  }
  ngAfterViewInit(): void {
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/shared/offset-swiper/offset-swiper.component.ts